import { render, staticRenderFns } from "./UncollectedHelp.vue?vue&type=template&id=459a5fe5&scoped=true&lang=pug&"
import script from "./UncollectedHelp.vue?vue&type=script&lang=js&"
export * from "./UncollectedHelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "459a5fe5",
  null
  
)

export default component.exports